import React from 'react';
import { Box, BoxProps, Button, Typography } from '@mui/material';
import { useLeafletContext } from '@react-leaflet/core';
// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { Stop } from '../models/tour.type';

export type StopCardProps = {
	title: string;
	categories: React.ReactNode[];
	image_src: string;
	children?: React.ReactNode;
	stop?: Stop;
	isExpanded?: boolean;
	setExpandedStopId?: (id: string) => void;
};

export const StopCard = React.memo(
	React.forwardRef<BoxProps, StopCardProps & BoxProps>(function StopCard(
		_p,
		ref
	) {
		const leaflet = useLeafletContext();
		return (
			<Box
				ref={ref}
				className="relative flex bg-white rounded-md overflow-hidden p-0.5"
				{..._p}
				onClick={(e) => {
					_p.onClick?.(e);
					leaflet.map.flyTo([_p.stop?.stop_location.latitude ?? 0, _p.stop?.stop_location.longitude ?? 0], 18, { duration: 0.3 })
				}}
			>
				<Box className="flex-1 flex flex-col justify-between">
					<Box className="flex items-center p-3 gap-2">
						<Typography variant="button" className="flex-1">{_p.title}</Typography>
						{_p.stop && !_p.setExpandedStopId ? <div style={{ height: 60, marginLeft: 10, marginTop: 5 }}>
						</div> :
							<Button
								variant="outlined"
								sx={{
									borderRadius: '50%',
									color: '#000',
									// border: 'none',
									borderColor: '#000',
									minWidth: 0,
									width: 32,
									height: 32,
									padding: 0
								}}
								onClick={(e) => {
									e.stopPropagation();
									leaflet.map.flyTo([_p.stop?.stop_location.latitude ?? 0, _p.stop?.stop_location.longitude ?? 0], 18, { duration: 0.3 })
								}}
							>
								<i className="fa-solid fa-location-crosshairs text-lg"></i>
							</Button>
						}
					</Box>

					<Box className="px-3 pb-2">
						<Box className="flex flex-wrap justify-start gap-1 mb-6">
							{_p.categories?.map((category) => (
								<Typography
									key={'cat' + category?.toString()}
									variant="body2"
									textTransform="capitalize"
									sx={{
										backgroundColor: '#ffcdd2',
										borderRadius: '8px',
										padding: '4px 8px'
									}}
								>
									{category}
								</Typography>
							))}
						</Box>
					</Box>
				</Box>

				{_p.stop?.s_smallDesc && _p.setExpandedStopId && (
					<Box
						onClick={(e) => {
							e.stopPropagation();
							if (!_p.isExpanded && _p.setExpandedStopId) {
								_p.setExpandedStopId(_p.stop?.id ?? '')
							} else if (_p.isExpanded && _p.setExpandedStopId) {
								_p.setExpandedStopId('')
							}
						}}
						sx={{
							position: 'absolute',
							bottom: 0,
							left: '50%',
							transform: 'translateX(-50%)',
							width: 24,
							height: 24,
							border: 'none',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							cursor: 'pointer',
							zIndex: 10
						}}
					>
						<i className={`fa-solid text-lg fa-chevron-${_p.isExpanded ? 'up' : 'down'}`}></i>
					</Box>
				)}
				{_p.image_src && (
					<Box style={{ position: 'relative', width: '110px' }}>
						<img
							src={_p.image_src}
							className="h-full w-full object-cover object-center rounded-md shadow-lg hover:opacity-90 hover:scale-[1.02] transition-all duration-300 border-2 border-gray-100 hover:shadow-xl hover:border-gray-200"
							style={{
								filter: 'brightness(1.05) contrast(1.02)',
								transform: 'translateZ(0)',
								backfaceVisibility: 'hidden',
							}}
						/>
					</Box>
				)}
			</Box>
		);
	})
);
